import { render } from "./BoardModalReadMember.vue?vue&type=template&id=1722bc42&scoped=true"
import script from "./BoardModalReadMember.vue?vue&type=script&lang=js"
export * from "./BoardModalReadMember.vue?vue&type=script&lang=js"

import "./BoardModalReadMember.vue?vue&type=style&index=0&id=1722bc42&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-1722bc42"

export default script